export const SITE = {
  name: "NK Science & Physics Academy",
  short: "NK Academy",
  tagline: "Learn. Understand. Excel.",
  phone: "7576926671",
  phoneIntl: "+917576926671",
  whatsapp: "917576926671",
  email: "nipukalita513@gmail.com",
  address: "Pakorkona, Hajo Road, Kamrup, Assam",
};

export const NAV = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Courses", id: "courses" },
  { label: "Why Us", id: "why" },
  { label: "FAQs", id: "faqs" },
  { label: "Contact", id: "contact" },
];

export const COURSES = [
  {
    tag: "Class 9 & 10",
    title: "Mathematics",
    icon: "sigma",
    desc: "Build rock-solid fundamentals with step-by-step problem solving and board-focused practice.",
    points: ["Algebra & Geometry", "NCERT + extra problems", "Weekly tests"],
  },
  {
    tag: "Class 9 & 10",
    title: "Science",
    icon: "flask",
    desc: "Physics, Chemistry & Biology taught with real-life examples and clear conceptual clarity.",
    points: ["Concept-first teaching", "Diagram practice", "Chapter handouts"],
  },
  {
    tag: "Class 11 & 12",
    title: "Physics",
    icon: "atom",
    desc: "In-depth Physics for CBSE & AHSEC — derivations, numericals and exam strategy done right.",
    points: ["CBSE & AHSEC syllabus", "Numerical mastery", "Doubt sessions"],
  },
];

export const WHY = [
  { t: "Affordable monthly fees", d: "Premium coaching that stays within every family's reach." },
  { t: "Small batch size", d: "Individual attention for every single student, always." },
  { t: "Regular doubt-clearing", d: "Dedicated sessions so no question goes unanswered." },
  { t: "Extra pre-exam classes", d: "Intensive revision drives right before examinations." },
  { t: "Chapter-wise handouts", d: "Printed study materials tailored to each chapter." },
  { t: "Concept-based teaching", d: "We build understanding, not rote memorisation." },
  { t: "Tests & analysis", d: "Regular tests with honest performance analysis." },
  { t: "Supportive environment", d: "A friendly space where students genuinely enjoy learning." },
];

export const FEATURES = [
  { t: "Experienced Faculty", d: "Mentors who know exactly how boards think.", icon: "graduation-cap" },
  { t: "Affordable Fee Structure", d: "Transparent, honest and budget-friendly.", icon: "wallet" },
  { t: "Doubt Clearing Classes", d: "Ask freely, understand deeply.", icon: "message-circle-question" },
  { t: "Free Chapter-wise Handouts", d: "Printed notes for every chapter.", icon: "file-text" },
  { t: "Exam-Oriented Prep", d: "Every class engineered for scores.", icon: "target" },
  { t: "Personalized Guidance", d: "A plan shaped around each student.", icon: "compass" },
];

export const HANDOUTS = [
  { subject: "Mathematics", cls: "Class 9 & 10", count: 24 },
  { subject: "Science", cls: "Class 9 & 10", count: 30 },
  { subject: "Physics (CBSE)", cls: "Class 11 & 12", count: 22 },
  { subject: "Physics (AHSEC)", cls: "Class 11 & 12", count: 20 },
];

export const GALLERY = [
  "https://customer-assets-rejwkqb3.emergentagent.net/job_nk-science-academy/artifacts/mrwunp5f_file_00000000836481faa39e4a9474153e89.png",
  "https://images.unsplash.com/photo-1758685848663-784d2f7051d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  "https://images.pexels.com/photos/4092754/pexels-photo-4092754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=940&q=80",
  "https://customer-assets-rejwkqb3.emergentagent.net/job_nk-science-academy/artifacts/29hsfma9_ChatGPT%20Image%20Jul%2022%2C%202026%2C%2008_34_00%20PM.png",
];

export const TESTIMONIALS = [
  { name: "Ananya Das", role: "Class 10 Board Student", quote: "Maths finally makes sense to me. The small batch means sir notices the moment I'm stuck. Scored 96 in my pre-boards!", initial: "A" },
  { name: "Rahul Kalita", role: "Class 12, AHSEC", quote: "Physics numericals used to scare me. The chapter handouts and doubt sessions changed everything. Highly recommend.", initial: "R" },
  { name: "Priya Sharma", role: "Parent of Class 9 student", quote: "Affordable fees and genuine care. My daughter actually looks forward to her Science classes now.", initial: "P" },
  { name: "Manish Deka", role: "Class 12, CBSE", quote: "The exam-oriented tests kept me sharp all year. The performance analysis showed me exactly where to improve.", initial: "M" },
];

export const FAQS = [
  { q: "What are the monthly fees?", a: "Our fees are kept affordable and vary by class and subject. Call or WhatsApp us at 7576926671 for the current fee structure — there are no hidden charges." },
  { q: "What are the class timings?", a: "We run morning and evening batches on weekdays with dedicated weekend doubt-clearing sessions. Timings are arranged to fit around school hours." },
  { q: "How large are the batches?", a: "We intentionally keep batches small so every student receives individual attention and personalised guidance." },
  { q: "Do you offer a free demo class?", a: "Yes! We offer a free demo class so students and parents can experience our teaching style before enrolling. Book yours today." },
  { q: "Which boards do you cover for Physics?", a: "For Class 11 & 12 Physics we cover both CBSE and AHSEC syllabi in depth." },
  { q: "Do you provide study materials?", a: "Absolutely — chapter-wise printed handouts and study materials are provided free to enrolled students." },
];

export const MANIFESTO_INTRO = "We provide quality coaching with personal attention and conceptual learning.";
